export default __webpack_public_path__ + "static/media/technique.ba0b0dc1.png";